import React from 'react'
import About from './About'
import Footer from '../../common/Footer'

export default function AboutPage() {
  return (
      <div>
          <About/>
          <Footer/>
    </div>
  )
}
